import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class Title extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): Title {
    if (!(value.length > 0)) {
      throw new Error('タイトルが入力されていません');
    }
    return new Title(value);
  }

  /** ラベル */
  static get label(): string {
    return 'タイトル';
  }

  /** プレースホルダー */
  static get placeholder(): string {
    return 'タイトル';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }

  /** キー */
  static get key(): string {
    return 'title';
  }

  /** タイプ */
  static get type(): string {
    return 'text';
  }

  /** 文字列にする */
  override toString() {
    return this.value;
  }
}
